import React, { PropsWithChildren, useMemo } from "react";
import { sharedLib } from "@shared/services/shared.service";
import { SubGroupDetailsContext } from "@shared/features/newMarketplace/SubGroupDetails.context";
import { skipToken } from "@reduxjs/toolkit/query";

interface SubGroupDetailsProviderProps {
  groupId?: number;
}

const SubGroupDetailsProvider = ({
  groupId,
  children,
}: PropsWithChildren<SubGroupDetailsProviderProps>) => {
  const getGroupOverviewQuery =
    sharedLib.sharedApi.marketplace.useGetGroupOverviewQuery(
      groupId ? { group_id: groupId } : skipToken,
      { refetchOnMountOrArgChange: true }
    );
  const getGroupDataQuery = sharedLib.sharedApi.common.useGetGroupDataQuery(
    groupId ? { sub_group_id: groupId } : skipToken
  );

  const groupOverview = getGroupOverviewQuery?.currentData;
  const groupData = getGroupDataQuery?.currentData;

  const value = useMemo(() => {
    return {
      groupId,
      groupOverview,
      getGroupOverviewQuery,
      getGroupDataQuery,
      groupData,
    };
  }, [getGroupOverviewQuery, getGroupDataQuery, groupId]);

  return (
    <SubGroupDetailsContext.Provider value={value}>
      {children}
    </SubGroupDetailsContext.Provider>
  );
};

export default SubGroupDetailsProvider;
